'use strict';

/* eslint-disable indent */

var formErrors = require('theme/js/checkout/formErrors');

$(document).ready(function () {
    // Copy delivery inputs values into invoice inputs
    $('.same-as-delivery label').on('click', function () {
        var copy = document.querySelector('.same-as-delivery').classList.contains('copied');

        if (!copy) {
            var deliveryAddress = $('.deliveryAddress').val();
            var deliveryCity = $('.deliveryCity').val();
            var deliveryPostalCode = $('.deliveryPostalCode').val();
            var deliveryEmail = $('.deliveryEmail').val();

            $('.invoiceAddress').val(deliveryAddress);
            $('.invoiceCity').val(deliveryCity);
            $('.invoicePostalCode').val(deliveryPostalCode);
            $('.invoiceEmail').val(deliveryEmail);
        }

        $('.same-as-delivery').toggleClass('copied');
    });

    $('.b2bregistration-form').submit(function (e) {
        e.preventDefault();

        var form = $(this);
        formErrors.clearPreviousErrors('.b2bregistration-form');
        grecaptcha.ready(function () { // eslint-disable-line
            grecaptcha.execute(form.attr('data-recaptcha-site-key'), { action: 'createaccount' }).then(function (token) { // eslint-disable-line
                $.ajax({
                    url: form.attr('action'),
                    type: form.attr('method'),
                    data: form.serialize() + '&token=' + token + '&action=createaccount', // data to be submitted
                    success: function (data) {
                        var successMessage = data.successMessage;
                        $('#b2bregistration-form--success-message').html(successMessage);
                        $('#b2bregistration-form--success-message').removeAttr('hidden');
                        $('#b2bregistration-form--error-message').attr('hidden', true);
                        $('[data-b2bregistration-form]').hide();
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('body').offset().top
                        }, 500);
                    },
                    error: function (errorData) {
                        var responseJson = errorData.responseJSON;
                        var errorMessage;
                        switch (errorData.status) {
                            case 400:
                                var fieldErrors = responseJson.fieldErrors;
                                if (fieldErrors.length) {
                                    fieldErrors.forEach(function (error) {
                                        if (Object.keys(error).length) {
                                            formErrors.loadFormErrors('.b2bregistration-form', error);
                                        }
                                    });
                                }
                                break;
                            case 500:
                                errorMessage = '';
                                if (responseJson.action == 'CSRF-AjaxFail') {
                                    errorMessage = 'Session timed out. Please reload the page and try again.';
                                } else {
                                    errorMessage = responseJson.serverErrors.join(', ');
                                }
                                $('#b2bregistration-form--error-message').html(errorMessage);
                                $('#b2bregistration-form--error-message').removeAttr('hidden');
                                break;
                            default:
                                errorMessage = 'An error has occured, please try again. If the problem persists please contact HSNG support.';
                                $('#b2bregistration-form--error-message').html(errorMessage);
                                $('#b2bregistration-form--error-message').removeAttr('hidden');
                        }
                        $('#b2bregistration-form--success-message').attr('hidden', true);
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('body').offset().top
                        }, 500);
                    }
                });
            });
        });
    });
});
